import { render, staticRenderFns } from "./DefaultBody.vue?vue&type=template&id=0a8687f1&scoped=true&"
import script from "./DefaultBody.vue?vue&type=script&lang=js&"
export * from "./DefaultBody.vue?vue&type=script&lang=js&"
import style0 from "./DefaultBody.vue?vue&type=style&index=0&id=0a8687f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8687f1",
  null
  
)

export default component.exports